import { shouldForwardProp } from '@mui/system';

const shouldForwardPropHelper = (prop, propsSet) => shouldForwardProp(prop) && !propsSet.has(String(prop));

export { shouldForwardPropHelper };
//# sourceMappingURL=shouldForwardHelper.js.map
